import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import IconButton from '@material-ui/core/IconButton';
import HistoryIcon from '@material-ui/icons/History';

const styles = theme => ({
  outerStyle: {
    height: 'inherit',
    width: '100%',
    padding: '32px 16px 36px 16px',
  },
  paperStyle: {
    height: '100%',
    position: 'relative',
  },
  titleStyle: {
    borderBottom: '1px solid lightgrey',
    padding: theme.spacing.unit * 2,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  contentStyle: {
    overflowY: 'auto',
    maxHeight: 'calc(100% - 66px)',
  },
  spacing: {
    padding: theme.spacing.unit * 2,
  },
  historyStyle: {
    position: 'absolute',
    right: '6px',
    top: '6px',
  },
});

class Panel extends React.Component {
  render() {
    const { classes, title, loadHistory, noSpacing } = this.props;
    return (
      <div className={classes.outerStyle}>
        <Paper className={classes.paperStyle} square={true}>
          {title ? (
            <Typography className={classes.titleStyle} variant="title">
              {title}
              {loadHistory ? (
                <IconButton
                  className={classes.historyStyle}
                  onClick={e => loadHistory(e)}
                >
                  <HistoryIcon />
                </IconButton>
              ) : (
                ''
              )}
            </Typography>
          ) : (
            ''
          )}
          <div
            className={classNames(classes.contentStyle, {
              [classes.spacing]: !noSpacing,
            })}
          >
            {this.props.children}
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(Panel);



// WEBPACK FOOTER //
// ./src/components/commons/Panel.js